import React from 'react'
import styled from '@emotion/styled'
import {Input, Switch} from 'antd'

const { Search } = Input

const StyledPermissionsBar = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: 20
})

const SearchProjects = styled(Search)({
  width: 350
})

const AccountAdminToggle = styled.div({
  marginLeft: 'auto',
  label: {
    marginRight: 10
  }
})

const PermissionsBar = ({ isAccountAdmin, onAccountAdminChange, onSearch, sameUser }) => {
  return (
    <StyledPermissionsBar>
      <SearchProjects placeholder="search projects" onChange={event => onSearch(event.target.value)} />
      <AccountAdminToggle>
        <label>ACCOUNT ADMIN</label>
        <Switch checked={isAccountAdmin} onChange={onAccountAdminChange} disabled={sameUser} />
      </AccountAdminToggle>
    </StyledPermissionsBar>
  )
}

export default PermissionsBar
